import React from 'react'
import { Link } from 'react-router-dom'
import MessageUtils from '../../../util/MessageUtils'
import MessageUI from '../../../widgets/output/MessageUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import IconButtonLinkUI from '../../../widgets/action/IconButtonLinkUI'
import './AlertRuleList.css'

const AlertRuleListUI = ({context, messageList, project, alertRuleList, onRefreshClick,
    priorityList, dueInDaysList, duePastDaysList, repeatIntervalDaysList,
    onDeleteClick
  }) =>
  <div className='prj_alerts'>
    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          project={project}
          alertRuleList={alertRuleList}
          onRefreshClick={onRefreshClick}
        />
      }
      right={
        <span />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        alertRuleList.map((alertRule, i) =>
          <RuleRowUI
            key={i}
            context={context}
            messageList={messageList}
            alertRule={alertRule}
            project={project}
            priorityList={priorityList}
            dueInDaysList={dueInDaysList}
            duePastDaysList={duePastDaysList}
            repeatIntervalDaysList={repeatIntervalDaysList}
            onDeleteClick={onDeleteClick}
          />
        )
      }
    </LRTableBodyUI>
  </div>

const RuleRowUI = ({context, alertRule, messageList, project,
    priorityList, dueInDaysList, duePastDaysList, repeatIntervalDaysList,
    onDeleteClick
  }) =>
  <LRTableRowUI
    context={context}
    left={
      <RowLeftUI
        messageList={messageList}
        alertRule={alertRule}
        priorityList={priorityList}
        dueInDaysList={dueInDaysList}
        duePastDaysList={duePastDaysList}
        repeatIntervalDaysList={repeatIntervalDaysList}
      />
    }
    right={
      <RowRightUI
        context={context}
        messageList={messageList}
        alertRule={alertRule}
        project={project}
        onDeleteClick={onDeleteClick}
      />
    }
  />

const RowLeftUI = ({alertRule, messageList,
    priorityList, dueInDaysList, duePastDaysList, repeatIntervalDaysList
  }) =>
  <table>
    <tbody>
      <RowLeftRowUI messageList={messageList} labelKey='c_task_priority' valueList={priorityList} value={alertRule.priority} />
      <RowLeftRowUI messageList={messageList} labelKey='c_task_due_in' valueList={dueInDaysList} value={alertRule.dueInDaysCode} />
      <RowLeftRowUI messageList={messageList} labelKey='c_repeat' valueList={repeatIntervalDaysList} value={alertRule.repeatIntervalDaysCode} />
      {
        alertRule.repeatIntervalDaysCode !== 'd0' &&
        <RowLeftRowUI messageList={messageList} labelKey='c_task_due_past' valueList={duePastDaysList} value={alertRule.duePastDaysCode} />
      }
    </tbody>
  </table>

const RowLeftRowUI = ({context, messageList, labelKey, valueList, value}) =>
  <tr>
    <td className='g_muted'>
      <MessageUI messageList={messageList} messageKey={labelKey} />
    </td>
    <td align='right'>
      <b>
        {
          valueList && valueList.filter(v => v.key === value).length > 0 &&
          ((valueList.filter(v => v.key === value))[0].value)
        }
      </b>
    </td>
  </tr>

const RowRightUI = ({context, messageList, alertRule, project, onDeleteClick}) =>
  <div className='g_flex_h'>
    {
      project.permissionList.includes('prj_manage') &&
      <React.Fragment>
        <Link className='icon icon-pencil tag' to={`/projects/${project.projectId}/alerts/${alertRule.alertRuleId}/update`}
          title={MessageUtils.getMessageValue(messageList, 'c_update')}
        />
        <div className='icon icon-trash-o tag g_link' onClick={onDeleteClick}
          data-id={alertRule.alertRuleId}
          title={MessageUtils.getMessageValue(messageList, 'c_delete')}>
        </div>
      </React.Fragment>
    }
  </div>

const ActionLeftUI = ({context, messageList, project, alertRuleList, onRefreshClick}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      project.permissionList.includes('prj_manage') && alertRuleList.length < 3 &&
      <IconButtonLinkUI messageList={messageList} icon='icon-plus' to={`/projects/${project.projectId}/alerts/create`} labelKey='c_set_alerts' />
    }
  </div>

export default AlertRuleListUI
